/* ==========================================================================
   MD FACETS - drawer footer enhancement

   Adds the result count to the "View results" button and puts a "Clear all
   filters" link underneath it, matching the filter design.

   Why JS and not Liquid: that button lives in <facets-drawer>'s footer SLOT,
   which is rendered by sections/main-collection.liquid - a 28KB file full of
   bespoke product-card logic. Editing it wholesale to add two lines is a poor
   risk/benefit trade, so this enhances the footer in place instead. The numbers
   come from data attributes that snippets/facets.liquid renders on the form,
   so they are still real Liquid values, not scraped from the page.
   ========================================================================== */
(function () {
  if (window.__mdFacetsFooter) return;
  window.__mdFacetsFooter = true;

  function enhance() {
    var drawer = document.querySelector('facets-drawer');
    if (!drawer) return;

    var footer = drawer.querySelector('[slot="footer"]');
    var form = drawer.querySelector('.facets');
    if (!footer || !form) return;

    var count = form.getAttribute('data-mdf-count');
    var clearUrl = form.getAttribute('data-mdf-clear-url') || '';

    // "View results" -> "View results (162)"
    var btn = footer.querySelector('button');
    if (btn && count) {
      var base = (btn.dataset.mdfBase || btn.textContent).trim().replace(/\s*\(\d+\)\s*$/, '');
      btn.dataset.mdfBase = base;
      var wanted = base + ' (' + count + ')';
      if (btn.textContent.trim() !== wanted) btn.textContent = wanted;
    }

    // "Clear all filters" under the button. Always visible - the merchant wants
    // it permanently available, not only once a filter is active.
    var existing = footer.querySelector('.mdf-clear');
    if (!existing && clearUrl) {
      var a = document.createElement('a');
      a.className = 'mdf-clear';
      a.href = clearUrl;
      a.innerHTML =
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.8" aria-hidden="true"><path d="M3 12a9 9 0 1 1 3 6.7"/>' +
        '<path d="M3 20v-5h5"/></svg>Clear all filters';
      footer.appendChild(a);
    } else if (existing && clearUrl) {
      existing.href = clearUrl;
    }
  }

  function boot() {
    enhance();

    // Prestige re-renders - and sometimes REPLACES - the facets markup on every
    // filter change, so observe the document rather than the drawer element:
    // an observer bound to the old <facets-drawer> dies when it is swapped out.
    new MutationObserver(function () { enhance(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
